<template>
    <div>
        <crm-content id="practice-details">
            <template slot="actionLeft">
                <vx-back-button />
                <h4>Practice Details</h4>
            </template>
            <div class="flex flex-wrap">
                <vx-card class="mb-8">
                    <div class="flex w-full flex-nowrap">
                        <h1 class="mb-2 mr-4">
                            {{ practice ? `${practice.name}` : 'Unknown' }}
                        </h1>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between">
                        <div class="flex w-1/2 flex-nowrap">
                            <vx-address
                                class="w-1/2 mb-2 mr-4"
                                :value="practice.address"
                            ></vx-address>
                        </div>
                        <div class="flex flex-col w-1/2 flex-nowrap">
                            Phone
                            <vx-phone class="mb-2" label="Phone" :value="practice.phone" />
                            Fax
                            <vx-phone class="mb-2" label="Fax" :value="practice.fax" />
                            Email Address
                            <vx-email
                                class="w-full mb-2 mr-4"
                                label="Email Address"
                                :value="practice.emailAddress"
                            ></vx-email>
                        </div>
                    </div>
                    <div class="flex-col">
                        <div style="font-weight: bold">Additional Notes</div>
                        <div>{{ practice.additionalNotes || 'None' }}</div>
                    </div>
                    <template slot="footer">
                        <vx-action-icon
                            v-if="userHasRole(['ADMINISTRATOR', 'ADMIN_OFFICER', 'SuperUser'])"
                            is-button
                            icon="Edit1Icon"
                            color="warning"
                            @click="showEditor = true"
                        />
                    </template>
                </vx-card>
            </div>
        </crm-content>
        <practice-editor
            v-if="showEditor"
            v-model="practice"
            :active.sync="showEditor"
            @close="showEditor = false"
        />
    </div>
</template>

<script>
import CrmContent from '../../crm/components/CrmContent.vue'
import GeneralPractitionersTable from '../generalPractitioners/GeneralPractitionersTable.vue'
import PracticeEditor from './PracticeEditor.vue'

export default {
    name: 'practice-details',
    components: {
        CrmContent,
        GeneralPractitionersTable,
        PracticeEditor
    },
    props: {
        practiceId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            address: null,
            isMarkLostOpen: false,
            isConvertOpen: false,
            preservedPractice: null,
            preservedAddress: null,
            showEditor: false,
            practice: {
                id: null,
                name: null,
                address: {
                    subPremise: {
                        _IsSet: false,
                        buildingName: null,
                        unit: null,
                        level: null
                    },
                    streetAddress: {
                        streetNumber: {
                            start: null,
                            end: null
                        },
                        streetName: null,
                        streetType: null,
                        streetSuffix: null
                    },
                    suburb: null,
                    state: {
                        shortName: null,
                        displayName: null,
                        name: null,
                        id: null
                    },
                    postcode: {
                        number: null,
                        state: {
                            shortName: null,
                            displayName: null,
                            name: null,
                            id: null
                        }
                    },
                    location: null,
                    gnaf: null,
                    country: null
                },
                phone: null,
                fax: null,
                emailAddress: null,
                additionalNotes: null
            }
        }
    },
    watch: {
        practiceId: {
            handler: async function (id) {
                this.getDetails()
            },
            immediate: true
        }
    },
    computed: {
        isDirty() {
            if (this.practice && this.preservedPractice) {
                return (
                    (this.practice.contact || {}).id != (this.preservedPractice.contact || {}).id ||
                    (this.practice.source || {}).id != (this.preservedPractice.source || {}).id ||
                    this.practice.bdmId != this.preservedPractice.bdmId ||
                    this.practice.description != this.preservedPractice.description ||
                    this.practice.expiryDate != this.preservedPractice.expiryDate
                )
            }
            return false
        },
        isPracticeConvertable() {
            if (this.practice.contact) {
                return true
                return this.practice.contact.accountId ? true : false
            }
        },
        practiceStatusLabel() {
            switch (this.practice.status) {
                case 'InProgress':
                    return 'In Progress'
                case 'Lost':
                    return 'Closed'
                case 'Converted':
                    return 'Converted'
                default:
                    return 'Practice Status Unknown'
            }
        }
    },
    methods: {
        revertChanges() {
            this.practice = this.deepCopy(this.preservedPractice)
            this.validate()
        },

        setPractice(practice) {
            this.preservedPractice = this.deepCopy(practice)
            this.practice = practice
        },

        async getDetails() {
            if (this.practiceId) {
                this.loading = true
                try {
                    var practice = await this.$api.admin.practice.fetchById(this.practiceId)
                    this.setPractice(practice)
                } catch (err) {
                    this.notifyServerError(err)
                    console.error(err)
                } finally {
                    this.loading = false
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
